import type { ActionFunctionArgs } from "react-router-dom";
import { billingAPI, APIError } from "../../lib/api";
import type { ActionResult } from "./auth.actions";
import type { BillingInterval } from "../../types/api";
import { parseFormData } from "../../utils";

export async function createCheckoutAction({
  request,
  params,
}: ActionFunctionArgs): Promise<ActionResult> {
  const { id } = params;

  if (!id) {
    return { success: false, error: "Organization ID is required" };
  }

  const formData = await parseFormData(request);
  const interval = formData.interval as BillingInterval;

  if (!interval || !["monthly", "yearly"].includes(interval)) {
    return { success: false, error: "Valid billing interval is required" };
  }

  const baseUrl = window.location.origin;
  const successUrl = `${baseUrl}/organizations/${id}/billing?checkout=success`;
  const cancelUrl = `${baseUrl}/organizations/${id}/billing?checkout=canceled`;

  try {
    const response = await billingAPI.createCheckout(id, {
      interval,
      successUrl,
      cancelUrl,
    });
    return { success: true, data: { url: response.url } };
  } catch (error) {
    if (error instanceof APIError) {
      return { success: false, error: error.message };
    }
    return { success: false, error: "An unexpected error occurred" };
  }
}

export async function createPortalAction({ params }: ActionFunctionArgs): Promise<ActionResult> {
  const { id } = params;

  if (!id) {
    return { success: false, error: "Organization ID is required" };
  }

  const baseUrl = window.location.origin;
  const returnUrl = `${baseUrl}/organizations/${id}/billing`;

  try {
    const response = await billingAPI.createPortal(id, { returnUrl });
    return { success: true, data: { url: response.url } };
  } catch (error) {
    if (error instanceof APIError) {
      return { success: false, error: error.message };
    }
    return { success: false, error: "An unexpected error occurred" };
  }
}

export async function cancelSubscriptionAction({
  params,
}: ActionFunctionArgs): Promise<ActionResult> {
  const { id } = params;

  if (!id) {
    return { success: false, error: "Organization ID is required" };
  }

  try {
    await billingAPI.cancel(id);
    return { success: true };
  } catch (error) {
    if (error instanceof APIError) {
      return { success: false, error: error.message };
    }
    return { success: false, error: "An unexpected error occurred" };
  }
}
